import { graphql } from "@/data-access/graphql";

export const TemplateLayoutSummaryFragment = graphql(`
  fragment TemplateLayoutSummaryFragment on TemplateLayout @_unmask {
    __typename
    id
    name
    description
    scope
    status
    canEdit
    slotCount
    briefingCount
    createdBy
    createdAt
    updatedBy
    updatedAt
  }
`);

export const TemplateLayoutFragment = graphql(`
  fragment TemplateLayoutFragment on TemplateLayout @_unmask {
    __typename
    id
    name
    description
    scope
    status
    canEdit
    slotCount
    briefingCount
    schemaVersion
    catalogVersion
    document
    createdBy
    createdAt
    updatedBy
    updatedAt
  }
`);
